export default __webpack_public_path__ + "media/images/7-841a25e43f72d7eb75d6c81d33a1578a.jpg";